import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  namespace: 'PAYMENT',
  entryPoint: '/payments',
  collectionName: 'payments',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/payment/triggers.js